import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {PaymentConfirmationValue} from '@store/balance/balance.types';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {now} from '@aviary/store/common/date.helpers';
import {NotificationDialog, NotificationDialogDefinition} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {NotificationDialogComponent} from '@aviary/dialogs/notification-dialog/notification-dialog.component';

export interface PaymentConfirmationDialogData {
  value: PaymentConfirmationValue;
}

@Component({
  selector: 'px-payment-confirmation',
  template: `
    <mx-notification-dialog [definition]="dialogDefinition">
      <div class="flex flex-col">
        <div class="text-title-large">Amount: {{ value.amount | format: 'CURRENCY' }}</div>
        <div>**** **** **** {{ value.last4 }}</div>
        <div>{{ now() | format: 'DATE_ONLY' }}</div>
        <div>{{ value.transactionId }}</div>
      </div>
    </mx-notification-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormatPipe, NotificationDialogComponent]
})
export class PaymentConfirmationDialog implements NotificationDialog<PaymentConfirmationDialogData> {
  public readonly dialogData: PaymentConfirmationDialogData = inject(MAT_DIALOG_DATA);
  public readonly value: PaymentConfirmationValue = this.dialogData.value;
  public readonly now = now;

  public readonly dialogDefinition: NotificationDialogDefinition = {
    title: 'Payment Confirmation',
    description: 'Thank you for your payment!',
    confirmButtonLabel: 'Close'
  };
}
